export default __webpack_public_path__ + "static/media/Edge WL - Flag Preferred.svg";